import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ReportEntity } from './report.entity';

@Index('_fk__report__id', ['fkReportId'], {})
@Entity('_report_tag')
export class ReportTagEntity extends BaseEntity {
	@Column('int', { name: '_fk__report__id', unsigned: true })
	public fkReportId!: number;

	@Column('varchar', { name: '_tag', length: 32 })
	public tag!: string;

	@ManyToOne(() => ReportEntity, (report) => report.reportTags, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__report__id', referencedColumnName: 'id' }])
	public fkReport!: ReportEntity;
}
